import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black opacity-50" }, null, -1)
const _hoisted_3 = { class: "flex z-20 w-96 h-48 bg-white p-4 items-center justify-center rounded-md shadow-md" }

import { useUserStore } from '../../stores/UserStore'
  import { storeToRefs } from 'pinia'
  import { useRouter } from 'vue-router'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalHome',
  props: {
    isVisible:Boolean
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  const router = useRouter()

  const {userEmail,userId } = storeToRefs(useUserStore())  
  
  
  
  
  const closeModal = () => {
    emit('close');
    // router.push(`/user/${userId.value}`);
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("button", {
              onClick: closeModal,
              class: "mt-4 px-4 h-12 py-2 bg-blue-500 text-white rounded-md"
            }, "Close")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})